import { Request } from '../../common/request.js'

// 获取记账宝下载页面所有数据
const getDownLoadList = obj => Request('App/AppDownPage/getInfo', 'GET', obj)

export default {
    getDownLoadList
}



// WEBPACK FOOTER //
// ./src/api/downloadList/index.js